export default class ForbiddenBusinessProfileRequestedError extends Error {
  constructor(message: string) {
    super(message);
  }
}
